module.exports = __webpack_public_path__ + "img/trilby_glover.2c83117a.jpg";